export default {
  "filter": {
    "title": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Products of the group „", _interpolate(_named("group")), "“"])},
    "type": {
      "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Type"])}
    },
    "apply": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Apply filters"])},
    "reset": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["RESET ALL"])}
  },
  "results": {
    "counter": {
      "info": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["<b>", _interpolate(_named("loaded")), "</b> of <b>", _interpolate(_named("total")), "</b> products are displayed"])},
      "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<b>Products</b> per page"])}
    },
    "model": {
      "attributes": {
        "id": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Model"])}
        }
      }
    },
    "pagination": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Page <b>", _interpolate(_named("current")), "</b> of <b>", _interpolate(_named("total")), "</b>"])}
  }
}